var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinished1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.28,126.53s-6.06,4.62-.25,10.72a.55.55,0,0,0,.38.16l53-.31s4.52-5.07.77-10.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.67,131.35c0,.06-6.59.11-14.73.11s-14.73-.05-14.73-.11,6.6-.11,14.73-.11S93.67,131.29,93.67,131.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.43,133.27s-3.1.1-6.92.1-6.93-.05-6.93-.1,3.1-.11,6.93-.11S85.43,133.21,85.43,133.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.09,136.93s.11-.61.28-1.59a22.39,22.39,0,0,0,.3-3.86,21.44,21.44,0,0,0-.38-3.86c-.18-1-.34-1.57-.31-1.58s.07.14.16.41a11.58,11.58,0,0,1,.3,1.14,18.67,18.67,0,0,1,.45,3.89,19.34,19.34,0,0,1-.37,3.89c-.11.49-.2.89-.29,1.15A2,2,0,0,1,99.09,136.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,126.12a1.59,1.59,0,0,1,.23.38,3.56,3.56,0,0,1,.24.48c.08.19.19.4.27.65a11,11,0,0,1,.5,1.75,13.73,13.73,0,0,1,.24,2.23,12.84,12.84,0,0,1-.2,2.23,10.39,10.39,0,0,1-.48,1.77c-.07.25-.18.46-.25.65s-.16.35-.23.48a2.62,2.62,0,0,1-.23.39s.26-.59.57-1.57a13.19,13.19,0,0,0,.43-1.75,14.9,14.9,0,0,0,.17-2.2,13.45,13.45,0,0,0-.21-2.19,12.43,12.43,0,0,0-.45-1.74C103.31,126.7,103,126.14,103,126.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.64,137a1.49,1.49,0,0,1-.25-.35,4.17,4.17,0,0,1-.24-.44c-.09-.18-.2-.38-.29-.61a9.22,9.22,0,0,1-.51-1.67,10.93,10.93,0,0,1-.21-2.14,11.38,11.38,0,0,1,.26-2.12A9.44,9.44,0,0,1,60,128c.1-.23.21-.43.3-.6a4,4,0,0,1,.26-.44,1.74,1.74,0,0,1,.26-.34s-.31.53-.68,1.44a9.74,9.74,0,0,0-.5,1.64,11.08,11.08,0,0,0-.25,2.09,11.43,11.43,0,0,0,.19,2.09,11.22,11.22,0,0,0,.46,1.65C60.35,136.46,60.68,137,60.64,137Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.92,138.3a2.7,2.7,0,0,1-.27-.41,4,4,0,0,1-.28-.49,6.53,6.53,0,0,1-.32-.69,11.16,11.16,0,0,1-.6-1.87,12.38,12.38,0,0,1-.3-2.39,12.17,12.17,0,0,1,.19-2.4,11.52,11.52,0,0,1,.52-1.89c.09-.27.2-.49.29-.7s.18-.37.26-.51a2.24,2.24,0,0,1,.25-.41s-.3.62-.66,1.67a12.86,12.86,0,0,0-.47,1.88,14.55,14.55,0,0,0-.17,2.36,12.93,12.93,0,0,0,.28,2.35,13.55,13.55,0,0,0,.55,1.86C54.59,137.69,55,138.27,54.92,138.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.43,153.23v10.14H83.82V153.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.09,158.39c0,.09,0,.18,0,.27a5.8,5.8,0,0,0,5.83,5.44h58.41v-.73H90.48a5.07,5.07,0,0,1-5.07-5.07h0a5.07,5.07,0,0,1,5.07-5.07h13.87v-1.07l-58.43.19A5.85,5.85,0,0,0,40.09,158.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.43,158.44c0,.06-4,.1-9,.1s-9,0-9-.1,4-.11,9-.11S103.43,158.38,103.43,158.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.15,160.72c0,.06-3.82.11-8.52.11s-8.52-.05-8.52-.11,3.81-.11,8.52-.11S103.15,160.66,103.15,160.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.43,162.81c0,.06-3.43.11-7.66.11s-7.66,0-7.66-.11,3.43-.11,7.66-.11S103.43,162.75,103.43,162.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.43,156.38c0,.06-4,.11-8.82.11s-8.82-.05-8.82-.11,3.95-.1,8.82-.1S103.43,156.32,103.43,156.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.15,154.33c0,.06-3.52.11-7.85.11s-7.85-.05-7.85-.11,3.51-.1,7.85-.1S103.15,154.27,103.15,154.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.17,152.52A13.38,13.38,0,0,0,45.93,154a7.51,7.51,0,0,0,.1,8.68,13.15,13.15,0,0,0,1.28,1.45,1.67,1.67,0,0,1-.42-.31,6.51,6.51,0,0,1-1-1,7.37,7.37,0,0,1-.1-8.86,6.39,6.39,0,0,1,.95-1.07A2.08,2.08,0,0,1,47.17,152.52Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2,152.31A12,12,0,0,0,44,153.78a7.51,7.51,0,0,0,.11,8.69,11.85,11.85,0,0,0,1.27,1.44,2.24,2.24,0,0,1-.42-.31,6,6,0,0,1-1-1,7.39,7.39,0,0,1-.11-8.86,6.91,6.91,0,0,1,1-1.07A1.59,1.59,0,0,1,45.2,152.31Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.88,152.52A14.89,14.89,0,0,0,83.64,154a7.51,7.51,0,0,0,.1,8.68A13.15,13.15,0,0,0,85,164.13a1.91,1.91,0,0,1-.42-.31,6.51,6.51,0,0,1-1-1,7.41,7.41,0,0,1-.1-8.86,6.86,6.86,0,0,1,1-1.07A2.51,2.51,0,0,1,84.88,152.52Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.91,152.31a12.58,12.58,0,0,0-1.24,1.47,7.49,7.49,0,0,0,.1,8.69A13,13,0,0,0,83,163.91a2.24,2.24,0,0,1-.42-.31,6.39,6.39,0,0,1-1-1,7.39,7.39,0,0,1-.11-8.86,6.91,6.91,0,0,1,.95-1.07A1.81,1.81,0,0,1,82.91,152.31Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.82,159.82l-.06-4.12a2.89,2.89,0,0,0-.14-1.06,1,1,0,0,0-.79-.66c-.51-.23-1.32.2-1.68.79a3.88,3.88,0,0,0-.4,2,27.27,27.27,0,0,0,.16,3.26,3.65,3.65,0,0,0,.38,1.49,1.25,1.25,0,0,0,2.36-.2A4.31,4.31,0,0,0,53.82,159.82Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5,158.63c0,.06-4.22.11-9.43.11s-9.43-.05-9.43-.11,4.22-.1,9.43-.1S76.5,158.58,76.5,158.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.91 152.12 49.8 142.51 55.03 142.51 55.21 152.12 49.91 152.12",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.72,144.22a13.62,13.62,0,0,1-2.43.11,13.62,13.62,0,0,1-2.43-.11,13.62,13.62,0,0,1,2.43-.11A13.62,13.62,0,0,1,54.72,144.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.72,145.7a13.62,13.62,0,0,1-2.43.11,13.62,13.62,0,0,1-2.43-.11,14.26,14.26,0,0,1,2.43-.1A14.26,14.26,0,0,1,54.72,145.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.72,147.19a15.61,15.61,0,0,1-2.43.1,15.61,15.61,0,0,1-2.43-.1,13.62,13.62,0,0,1,2.43-.11A13.62,13.62,0,0,1,54.72,147.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.72,148.67a13.62,13.62,0,0,1-2.43.11,13.62,13.62,0,0,1-2.43-.11,13.62,13.62,0,0,1,2.43-.11A13.62,13.62,0,0,1,54.72,148.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.72,150.15a13.62,13.62,0,0,1-2.43.11,13.62,13.62,0,0,1-2.43-.11,13.62,13.62,0,0,1,2.43-.11A13.62,13.62,0,0,1,54.72,150.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.52,142.26h58a27.22,27.22,0,0,1,0,10.38H49.77v-.71h3.52A1.66,1.66,0,0,0,55,150.27v-5.75a1.66,1.66,0,0,0-1.67-1.66H49.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.22,147.45h1a.17.17,0,0,1,.1,0,.2.2,0,0,1,.11.18s0,.05,0,.07a2.17,2.17,0,0,1-.07.24,2.72,2.72,0,0,1-.6,1.1,1.15,1.15,0,0,1-.83.42h-.11a.92.92,0,0,1-.66-.48,2.19,2.19,0,0,1-.29-1.16A2.92,2.92,0,0,1,62,147a2.74,2.74,0,0,1,.57-1.13,1.18,1.18,0,0,1,.87-.46.81.81,0,0,1,.37.09,1.13,1.13,0,0,1,.56.7.16.16,0,0,1,0,.1.18.18,0,0,1,0,.1.22.22,0,0,1-.18.11h-.07a.2.2,0,0,1-.13-.14h0a.71.71,0,0,0-.12-.23A.51.51,0,0,0,63,146a1.72,1.72,0,0,0-.53.76,2.88,2.88,0,0,0-.23,1.09,2,2,0,0,0,.17.86.55.55,0,0,0,.5.37.67.67,0,0,0,.47-.28,2.58,2.58,0,0,0,.5-.9h-.7a.25.25,0,0,1-.23-.24s0,0,0-.07A.22.22,0,0,1,63.22,147.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.51,145.57l0,.07c0,.14.27,1.34.68,3.59a.09.09,0,0,1,0,.05.23.23,0,0,1,0,.11.19.19,0,0,1-.17.1h0a.17.17,0,0,1-.16-.14l-.23-1.2h-1.2l-.57,1.2a.05.05,0,0,1,0,0,.21.21,0,0,1-.18.1.23.23,0,0,1-.11,0,.2.2,0,0,1-.09-.17.15.15,0,0,1,0-.07q0-.12.18-.39c.83-1.82,1.33-2.89,1.49-3.22a.23.23,0,0,1,.2-.15A.22.22,0,0,1,66.51,145.57Zm-.26.8-.64,1.36h.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.75,149.49H68a.2.2,0,0,1-.11,0,.3.3,0,0,1-.1-.22h0c0-.07.16-1.26.48-3.58,0,0,0,0,0-.07a.19.19,0,0,1,.19-.13l.09,0a.19.19,0,0,1,.11.19c0,.15,0,.48-.12,1-.19,1.52-.3,2.33-.31,2.41h1.49a.23.23,0,0,1,.11,0,.18.18,0,0,1,.13.19.17.17,0,0,1,0,.07A.22.22,0,0,1,69.75,149.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.13,145.57l0,.07c0,.14.27,1.34.68,3.59a.09.09,0,0,1,0,.05.23.23,0,0,1,0,.11.19.19,0,0,1-.17.1h0a.17.17,0,0,1-.16-.14l-.23-1.2H71l-.58,1.2a.05.05,0,0,1,0,0,.21.21,0,0,1-.17.1.24.24,0,0,1-.12,0,.2.2,0,0,1-.09-.17.15.15,0,0,1,0-.07l.18-.39c.83-1.82,1.33-2.89,1.49-3.22a.25.25,0,0,1,.2-.15A.22.22,0,0,1,72.13,145.57Zm-.26.8-.64,1.36h.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.92,147.63c.13.38.24.67.31.87.18.5.27.76.27.79a.2.2,0,0,1,0,.11.19.19,0,0,1-.35-.05l0-.09c-.1-.21-.25-.62-.47-1.23l-1,1.35a.2.2,0,0,1-.18.11.23.23,0,0,1-.11,0,.18.18,0,0,1-.1-.17v0a.55.55,0,0,1,.11-.17c.33-.43.7-.94,1.1-1.53a3.43,3.43,0,0,1-.12-.33c-.38-1-.56-1.51-.56-1.55a.19.19,0,0,1,0-.1.17.17,0,0,1,.16-.11.23.23,0,0,1,.2.12l.58,1.57,1.17-1.59a.23.23,0,0,1,.18-.09.16.16,0,0,1,.1,0,.2.2,0,0,1,.1.19.37.37,0,0,1,0,.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.24,145.48a.2.2,0,0,1,.1,0,.22.22,0,0,1,.11.18q-.44,3.39-.48,3.66a2.2,2.2,0,0,1-.37.95,1.35,1.35,0,0,1-1.16.57,1.52,1.52,0,0,1-.56-.14,1.19,1.19,0,0,1-.61-.55.17.17,0,0,1,0-.1.19.19,0,0,1,0-.1.19.19,0,0,1,.18-.1.21.21,0,0,1,.16.08,1.12,1.12,0,0,0,.89.51.9.9,0,0,0,.7-.35,1.9,1.9,0,0,0,.38-1.1.93.93,0,0,1-.25.27,1,1,0,0,1-.63.21h-.12a.92.92,0,0,1-.66-.48,2.08,2.08,0,0,1-.29-1.16q0-.32,0-.66c0-.35.11-.85.23-1.5,0,0,0,0,0-.06a.19.19,0,0,1,.19-.14.19.19,0,0,1,.1,0,.16.16,0,0,1,.1.16c0,.11,0,.37-.09.8a11.57,11.57,0,0,0-.14,1.22,2.3,2.3,0,0,0,.16.94c.11.29.29.43.51.43h.07a.93.93,0,0,0,.53-.42,2.8,2.8,0,0,0,.43-1l.26-2a.32.32,0,0,1,0-.09A.18.18,0,0,1,79.24,145.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.3,152.78c-.06,0-.1-2.39-.1-5.33s0-5.33.1-5.33.11,2.39.11,5.33S105.36,152.78,105.3,152.78Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.87,152.78c-.06,0-.1-2.39-.1-5.33s0-5.33.1-5.33.11,2.39.11,5.33S57.93,152.78,57.87,152.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.32,152.78c-.06,0-.11-2.39-.11-5.33s.05-5.33.11-5.33.11,2.39.11,5.33S106.38,152.78,106.32,152.78Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.92,152.78c-.06,0-.1-2.39-.1-5.33s0-5.33.1-5.33.11,2.39.11,5.33S57,152.78,56.92,152.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.25,143.88v0l6.13,4.94,0,0-.07,0-.81.22-5.17,1.35h0l-4.68-2-1.33-.56-.35-.16-.09,0h0l.09,0,.36.15,1.33.55,4.7,2h0L96.52,149l.81-.22v.07l-6.11-5h0",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.81 148.03 97.15 148.34 97.59 148.25 97.4 148.66 97.63 149.06 97.17 149 96.87 149.34 96.78 148.89 96.36 148.71 96.77 148.49 96.81 148.03",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.94 149.98 91.16 150.17 91.45 150.09 91.34 150.36 91.5 150.61 91.21 150.59 91.02 150.82 90.95 150.54 90.67 150.43 90.92 150.28 90.94 149.98",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.44 147.32 84.81 147.34 85.03 147.05 85.12 147.41 85.47 147.53 85.16 147.72 85.14 148.09 84.86 147.86 84.51 147.96 84.65 147.62 84.44 147.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 143.95 99.92 143.98 100.15 143.69 100.24 144.04 100.58 144.17 100.27 144.36 100.26 144.73 99.98 144.5 99.63 144.6 99.76 144.26 99.56 143.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.95 143.72 91.18 143.73 91.33 143.55 91.39 143.77 91.6 143.85 91.41 143.98 91.4 144.21 91.22 144.06 91 144.13 91.08 143.91 90.95 143.72",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.07,144.21s-2,0-4.43-.15-4.42-.21-4.42-.23,2,0,4.43.15S100.07,144.19,100.07,144.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.29,142.17H43.51c-.77-1.75-1-3.41,0-4.9h58.78A5.64,5.64,0,0,1,102.29,142.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.68,
    y: 138.67,
    width: 31.85,
    height: 1.78,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.77,142.19s-.23-.18-.47-.59a4.31,4.31,0,0,1-.53-1.74,4.37,4.37,0,0,1,.22-1.8,1.63,1.63,0,0,1,.36-.66,6.58,6.58,0,0,1-.21.71,5,5,0,0,0-.16,1.74,4.83,4.83,0,0,0,.46,1.68A6.45,6.45,0,0,1,45.77,142.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,142.19s-.23-.18-.46-.59a4.15,4.15,0,0,1-.54-1.74,4.37,4.37,0,0,1,.22-1.8,1.78,1.78,0,0,1,.36-.66,6.58,6.58,0,0,1-.21.71,5,5,0,0,0-.16,1.74,4.83,4.83,0,0,0,.46,1.68A6.45,6.45,0,0,1,47,142.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.92,142.08a10.51,10.51,0,0,0,.41-2.39,9.5,9.5,0,0,0-.39-2.4,4.2,4.2,0,0,1,.6,2.4A4.38,4.38,0,0,1,99.92,142.08Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.82,142.07c-.06,0,.19-1,.18-2.35s-.25-2.32-.18-2.34a5.58,5.58,0,0,1,.39,2.34A5.66,5.66,0,0,1,98.82,142.07Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.04,
    y: 69.34,
    width: 20.93,
    height: 22.2,
    transform: "translate(-0.43 0.75) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.87,
    y: 69.22,
    width: 20.93,
    height: 22.2,
    transform: "matrix(1, -0.01, 0.01, 1, -0.43, 0.86)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,75.52c13.91.12,27.86,0,41.76-.19a.22.22,0,0,0,0-.44q-20.86-.12-41.76.25a.19.19,0,0,0,0,.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.98,
    y: 91.21,
    width: 38.03,
    height: 18.09,
    transform: "translate(-0.54 0.73) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.83,
    y: 91.01,
    width: 38.03,
    height: 18.09,
    transform: "translate(-0.53 0.93) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,96.35c25.26.28,50.61,0,75.87-.38a.22.22,0,0,0,0-.44c-25.26-.13-50.62-.12-75.88.44a.19.19,0,0,0,0,.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.65,
    y: 193.63,
    width: 38.03,
    height: 18.09,
    transform: "translate(-1.08 0.55) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 193.42,
    width: 38.03,
    height: 18.09,
    transform: "translate(-1.08 0.75) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.63,198.76c25.26.29,50.61,0,75.88-.37a.23.23,0,0,0,0-.45c-25.26-.13-50.61-.12-75.87.44a.19.19,0,0,0,0,.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.12,
    y: 61.75,
    width: 9.59,
    height: 47.73,
    transform: "translate(-0.46 0.35) rotate(-0.31)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.53,
    y: 43.95,
    width: 9.59,
    height: 65.65,
    transform: "translate(-0.41 0.4) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.18,
    y: 56.19,
    width: 14.91,
    height: 53.2,
    transform: "translate(-0.44 0.47) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.84,66.4a55.39,55.39,0,0,1-7.45.25,55.48,55.48,0,0,1-7.46-.25,52.57,52.57,0,0,1,7.46-.26A52.48,52.48,0,0,1,93.84,66.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.84,64.16a54.33,54.33,0,0,1-7.45.26,54.42,54.42,0,0,1-7.46-.26,54.42,54.42,0,0,1,7.46-.26A54.33,54.33,0,0,1,93.84,64.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.84,101.34a52.48,52.48,0,0,1-7.45.26,52.57,52.57,0,0,1-7.46-.26,54.42,54.42,0,0,1,7.46-.26A54.33,54.33,0,0,1,93.84,101.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.84,99.11a54.33,54.33,0,0,1-7.45.26,54.42,54.42,0,0,1-7.46-.26,54.42,54.42,0,0,1,7.46-.26A54.33,54.33,0,0,1,93.84,99.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.63,94.23c-.15,0-.26-5.37-.26-12s.11-12,.26-12,.25,5.36.25,12S86.77,94.23,86.63,94.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 69.21,
    width: 16.22,
    height: 40.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.77,55.13A2.76,2.76,0,1,1,74,52.38,2.75,2.75,0,0,1,76.77,55.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.16,
    y: 62.72,
    width: 1.7,
    height: 39.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.27,
    y: 164.43,
    width: 168.89,
    height: 5.78,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.27,
    y: 109.63,
    width: 168.89,
    height: 5.78,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.74,
    y: 211.85,
    width: 134.42,
    height: 5.45,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.27,
    y: 114.27,
    width: 6.44,
    height: 54.52,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.77,
    y: 164.43,
    width: 6.44,
    height: 52.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,139.65l-4,5.69s8.91,2.47,8.91,10.39-5.45,9.4-11.38,9.4-11.63-1.73-11.39-9.65,7.67-10.89,7.67-10.89l-3.71-4.94Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.69,
    y: 343.38,
    width: 178.78,
    height: 82.45,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.21,421.94H243.78V347.72H414.21Zm-169.32-1.11H413.1v-72H244.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.47,
    y: 343.38,
    width: 43.68,
    height: 82.45,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.33,370.69H413.66a.23.23,0,0,0,0-.45H244.33a.23.23,0,0,0,0,.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.55,370.46a185.84,185.84,0,0,0,.06-22.39.23.23,0,0,0-.46,0,185.84,185.84,0,0,0,.06,22.39.17.17,0,0,0,.34,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.12,359.27a2.31,2.31,0,1,1-2.3-2.31A2.3,2.3,0,0,1,375.12,359.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.26,359.27A2.31,2.31,0,1,1,284,357,2.3,2.3,0,0,1,286.26,359.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.3,384.83a2.31,2.31,0,1,1-2.3-2.31A2.31,2.31,0,0,1,331.3,384.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.06 425.83 251.86 477.6 257.03 477.6 274 425.83 261.06 425.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.82 425.83 413.52 477.69 408.34 477.69 392.88 425.83 405.82 425.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.38 425.83 449.1 477.69 443.92 477.69 427.44 425.83 440.38 425.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.15,408.17a2.31,2.31,0,1,1-2.31-2.31A2.31,2.31,0,0,1,331.15,408.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.33,396.22H413.66a.23.23,0,0,0,0-.45H244.33a.23.23,0,0,0,0,.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.95,
    y: 283.01,
    width: 11,
    height: 54.06,
    transform: "translate(645.7 -29.05) rotate(89.7)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.29,
    y: 304.64,
    width: 17.1,
    height: 60.25,
    transform: "translate(673.79 -7.84) rotate(89.7)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.4,343c-.17,0-.3-3.83-.3-8.55s.13-8.55.3-8.55a63.33,63.33,0,0,1,.29,8.55A63.33,63.33,0,0,1,359.4,343Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.93,343a62.27,62.27,0,0,1-.3-8.55,62.27,62.27,0,0,1,.3-8.55,63.33,63.33,0,0,1,.29,8.55A63.33,63.33,0,0,1,361.93,343Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.82,343a63.33,63.33,0,0,1-.29-8.55,63.33,63.33,0,0,1,.29-8.55,63.33,63.33,0,0,1,.29,8.55A63.33,63.33,0,0,1,319.82,343Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.35,343a63.33,63.33,0,0,1-.29-8.55,63.33,63.33,0,0,1,.29-8.55,63.33,63.33,0,0,1,.29,8.55A63.33,63.33,0,0,1,322.35,343Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.87,334.76c0-.17,6.08-.3,13.58-.3s13.57.13,13.57.3-6.07.29-13.57.29S327.87,334.92,327.87,334.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.92,
    y: 283.48,
    width: 11,
    height: 74.34,
    transform: "translate(675.19 -37.46) rotate(89.7)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,324.59A3.56,3.56,0,1,1,386.5,321,3.53,3.53,0,0,1,383,324.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.34,
    y: 296.15,
    width: 2.2,
    height: 49.77,
    transform: "translate(669.47 -27.41) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.65,
    y: 155.52,
    width: 84.71,
    height: 88.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.92,
    y: 155.52,
    width: 84.71,
    height: 88.3,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.65,243.84H329.89V155.49h84.76Zm-84.71-.05H414.6V155.54H329.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.3,
    y: 167.39,
    width: 61.93,
    height: 64.56,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.3,232.38a10.38,10.38,0,0,1-1.53,1.77c-1,1-2.37,2.46-3.93,4s-3,2.91-4,3.88a10.38,10.38,0,0,1-1.79,1.49,9.58,9.58,0,0,1,1.52-1.77c1-1.05,2.38-2.46,4-4s3-2.91,4-3.88A9.61,9.61,0,0,1,341.3,232.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.23,232.22a9.77,9.77,0,0,1,1.78,1.53c1.05,1,2.46,2.37,4,3.93s2.91,3,3.88,4a10,10,0,0,1,1.49,1.79A9.58,9.58,0,0,1,412.6,242c-1.05-1-2.46-2.38-4-3.95s-2.91-3-3.88-4.05A10.6,10.6,0,0,1,403.23,232.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.07,167.56a9.8,9.8,0,0,1,1.52-1.78c1-1,2.38-2.45,3.94-4s3-2.9,4.05-3.87a9.08,9.08,0,0,1,1.79-1.49,10.42,10.42,0,0,1-1.52,1.77c-1,1-2.39,2.46-4,4s-3,2.91-4,3.88A10,10,0,0,1,403.07,167.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.13,167.72a10,10,0,0,1-1.77-1.53c-1.05-1-2.46-2.38-4-3.94s-2.9-3-3.87-4a10.38,10.38,0,0,1-1.49-1.79,9.1,9.1,0,0,1,1.77,1.52c1,1,2.46,2.38,4,3.94s2.91,3,3.88,4.06A9.24,9.24,0,0,1,341.13,167.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.07,232a2.15,2.15,0,0,1,0-.32c0-.22,0-.51,0-.9q0-1.22,0-3.48c0-3.06,0-7.51-.06-13.16,0-11.31-.07-27.42-.12-46.7l.24.24-61.76,0h0l.28-.27c0,23.69,0,45.86,0,64.56l-.24-.24,44.72.12,12.56.06,3.33,0h.86l.3,0H402l-3.28,0-12.51.06-44.87.12h-.23V232c0-18.7,0-40.87,0-64.56v-.28h.28l61.76,0h.24v.24c-.05,19.35-.09,35.51-.12,46.85,0,5.63-.05,10.06-.06,13.11,0,1.49,0,2.64,0,3.43,0,.38,0,.67,0,.88S403.07,232,403.07,232Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.94,
    y: 189.33,
    width: 20.67,
    height: 20.67,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.4,
    y: 426.19,
    width: 60.63,
    height: 8.33,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.14,434.62H112.3v-8.54h60.84Zm-60.63-.21h60.42v-8.12H112.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.02 431.74 126.75 474.8 159.04 474.8 167.48 434.52 118.02 431.74",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.02 470.73 122.68 477.13 161.93 477.13 167.48 470.73 118.02 470.73",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.44,433c-.12,0-.27-19.95-.34-44.55s0-44.55.09-44.55.27,19.94.34,44.55S140.56,433,140.44,433Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,383.08a2.74,2.74,0,0,1-.17.47l-.54,1.29-.39.93c-.13.35-.26.73-.41,1.13s-.3.84-.46,1.3-.29,1-.45,1.48a61.34,61.34,0,0,0-1.7,7.42,91.93,91.93,0,0,0-.94,9.29,126,126,0,0,0,.48,17c.2,2.16.39,3.91.54,5.12.06.56.11,1,.15,1.39a3,3,0,0,1,0,.49,1.48,1.48,0,0,1-.11-.48c-.07-.36-.14-.82-.24-1.38-.19-1.2-.44-2.95-.67-5.11a112.27,112.27,0,0,1-.61-17,84.14,84.14,0,0,1,1-9.33,54.84,54.84,0,0,1,1.8-7.45c.17-.52.3-1,.48-1.48s.34-.89.5-1.29.3-.78.44-1.13.3-.64.43-.92c.25-.51.45-.93.62-1.26A1.72,1.72,0,0,1,154,383.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.4,367a5.58,5.58,0,0,1-.2.66c-.15.46-.36,1.08-.63,1.85-.14.41-.29.86-.46,1.34s-.31,1-.49,1.61c-.35,1.16-.76,2.47-1.13,3.94-.19.74-.4,1.51-.61,2.31s-.37,1.65-.57,2.52c-.42,1.74-.72,3.62-1.12,5.59-.66,4-1.25,8.34-1.66,13s-.55,9-.61,13.06,0,7.65.21,10.68c.05,1.52.15,2.89.23,4.1s.14,2.24.22,3.09.11,1.47.15,1.95a4.49,4.49,0,0,1,0,.69,3.72,3.72,0,0,1-.11-.68c-.06-.48-.13-1.13-.23-1.94s-.2-1.89-.29-3.09-.23-2.58-.3-4.1c-.2-3-.29-6.67-.3-10.7s.2-8.46.58-13.09,1-9,1.7-13c.4-2,.72-3.86,1.16-5.6q.31-1.31.6-2.52c.22-.8.43-1.57.64-2.31.38-1.47.81-2.78,1.19-3.93.19-.57.36-1.11.52-1.61s.35-.92.5-1.32c.3-.77.54-1.38.71-1.83A3.63,3.63,0,0,1,152.4,367Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.61,436.53a.89.89,0,0,1,0-.23q0-.27-.06-.69c0-.64-.1-1.52-.17-2.64-.15-2.33-.36-5.64-.61-9.72-.53-8.2-1.29-19.53-2.67-32-.7-6.23-1.52-12.15-2.37-17.52-.45-2.67-.86-5.22-1.33-7.59s-.89-4.58-1.31-6.59-.84-3.82-1.2-5.41-.69-3-1-4.08-.48-1.95-.63-2.57c-.07-.27-.12-.49-.16-.67s0-.23,0-.23a.73.73,0,0,1,.09.22l.19.66L126,350c.31,1.11.67,2.47,1,4.06s.84,3.39,1.26,5.4.92,4.21,1.36,6.59.91,4.92,1.37,7.6c.87,5.37,1.7,11.29,2.41,17.53,1.38,12.47,2.09,23.82,2.54,32,.23,4.11.38,7.43.47,9.73.05,1.12.08,2,.1,2.65,0,.28,0,.5,0,.68A2.17,2.17,0,0,1,136.61,436.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,353.49c-.27-2.82-3.12-5-6-5a9.43,9.43,0,0,0-7.22,3.92,22.68,22.68,0,0,0-3.48,7.72,52.38,52.38,0,0,0-2.13,20.53c.81,6.88,3.6,13.65,8.54,18.51.8.79,1.84,1.58,2.94,1.34a3.46,3.46,0,0,0,1.55-1,45.94,45.94,0,0,0,14.92-34.93c-.08-2.62-.42-5.34-1.87-7.52s-4.83-4.49-7.29-3.62",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.19,343.9l-36-21.27a1.7,1.7,0,0,1-.88-.89c-.14-.53.26-1,.65-1.44a24.85,24.85,0,0,1,19.26-7.57,22,22,0,0,1,17.42,10.83c3.48,6.22,3.59,14.44-.4,20.34",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.34,315.84l.47-.06c.31,0,.77-.07,1.36-.06a26.68,26.68,0,0,1,5,.39,29.27,29.27,0,0,1,23.34,21.12,27.57,27.57,0,0,1,.89,4.93,9.66,9.66,0,0,1,0,1,1.79,1.79,0,0,1-.27.79,6,6,0,0,0,0-1.82,30.45,30.45,0,0,0-1-4.87,29.47,29.47,0,0,0-23.09-20.9,32,32,0,0,0-5-.53C110,315.86,109.34,315.88,109.34,315.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.31,329.22a8.67,8.67,0,0,1-1.82.83c-1.15.45-2.75,1-4.55,1.6s-3.44,1-4.64,1.32a8.42,8.42,0,0,1-2,.37,10.07,10.07,0,0,1,1.89-.67l4.59-1.43,4.58-1.48A9.34,9.34,0,0,1,135.31,329.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.63,314a14.78,14.78,0,0,1,.43,4,15.55,15.55,0,0,1-.22,4,25.75,25.75,0,0,1-.21-4A25,25,0,0,1,129.63,314Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.83,322.23a15,15,0,0,1,2.62-.92c1.63-.51,3.91-1.15,6.46-1.76s4.86-1.08,6.55-1.38a15.22,15.22,0,0,1,2.75-.37,19.19,19.19,0,0,1-2.69.67c-1.67.37-4,.89-6.51,1.5s-4.82,1.2-6.48,1.63A19.31,19.31,0,0,1,103.83,322.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,347.36c-3.1-2.35-6.37-2.81-10.26-2.66a31.35,31.35,0,0,0-11.24,2.9c-6.08,2.66-11.79,6.59-15.42,12.14s-4.9,12.91-2.18,19a2.69,2.69,0,0,0,1.23,1.49,3,3,0,0,0,2-.15c6.91-2.26,13.87-4.53,20.23-8.07s12.14-8.44,15.55-14.86a12.67,12.67,0,0,0,1.64-4.93,6.15,6.15,0,0,0-1.59-4.82",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.05,346.63a3.63,3.63,0,0,1-.5.2l-1.45.5-1,.35-1.22.48c-.88.35-1.89.71-3,1.22l-1.7.78c-.59.27-1.17.6-1.8.92-1.25.61-2.52,1.4-3.87,2.2A61.32,61.32,0,0,0,95.25,366.7c-1,1.23-1.9,2.39-2.67,3.56-.4.57-.8,1.11-1.15,1.66s-.66,1.08-1,1.58c-.65,1-1.13,2-1.59,2.78-.23.42-.45.8-.63,1.16l-.48,1c-.28.57-.5,1-.68,1.37a2.53,2.53,0,0,1-.26.47,2.18,2.18,0,0,1,.18-.5l.61-1.41q.2-.47.45-1c.17-.36.38-.75.6-1.17.44-.84.9-1.81,1.54-2.82l1-1.61c.34-.56.74-1.1,1.13-1.69.77-1.18,1.7-2.35,2.66-3.61A66.57,66.57,0,0,1,102,359a65.87,65.87,0,0,1,8.26-6.08c1.37-.79,2.65-1.57,3.92-2.18.63-.31,1.22-.64,1.82-.9l1.71-.76c1.09-.5,2.12-.83,3-1.17.45-.16.86-.32,1.24-.44l1.07-.32,1.47-.42A3.1,3.1,0,0,1,125.05,346.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.82,359.75a73.91,73.91,0,0,1-7.54,2.43,72.91,72.91,0,0,1-7.66,2,75,75,0,0,1,7.54-2.43A70,70,0,0,1,100.82,359.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.51,376.39a13.47,13.47,0,0,1-.16-2.35c0-1.45,0-3.46,0-5.68s.19-4.22.31-5.67a12.33,12.33,0,0,1,.29-2.34,13.87,13.87,0,0,1,0,2.36c0,1.59-.11,3.52-.17,5.66s-.11,4.08-.15,5.67A11.58,11.58,0,0,1,100.51,376.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.77,369.12c-.12,0-.5-4.07-.85-9.11s-.53-9.13-.41-9.14.5,4.07.84,9.11S114.89,369.12,114.77,369.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,350.47a13.73,13.73,0,0,1,2.42-.07c1.49,0,3.55.05,5.82.13s4.33.17,5.82.25a13.12,13.12,0,0,1,2.41.24,13.73,13.73,0,0,1-2.42.07c-1.49,0-3.55-.06-5.82-.13s-4.33-.17-5.82-.26A12.7,12.7,0,0,1,97,350.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.25,400.12a1.43,1.43,0,0,1-.06-.48q0-.54-.06-1.38c0-1.21-.07-2.95,0-5.11s.19-4.72.44-7.56.69-5.95,1.27-9.19,1.32-6.3,2.05-9.06,1.53-5.21,2.25-7.25,1.35-3.67,1.82-4.78c.23-.52.41-.95.55-1.28a2.79,2.79,0,0,1,.22-.44,1.93,1.93,0,0,1-.14.47c-.12.34-.28.77-.47,1.31-.43,1.12-1,2.77-1.69,4.82s-1.42,4.5-2.15,7.25-1.42,5.8-2,9-1,6.33-1.3,9.16-.46,5.38-.54,7.53-.11,3.89-.11,5.09c0,.57,0,1,0,1.39A2.91,2.91,0,0,1,131.25,400.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.15,376.52a10.26,10.26,0,0,1-1.44,1.58c-.93.93-2.26,2.18-3.77,3.5s-2.92,2.48-4,3.28a9.58,9.58,0,0,1-1.75,1.22,11.08,11.08,0,0,1,1.56-1.45l3.88-3.37,3.84-3.4A11,11,0,0,1,133.15,376.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.56,385.71a14.21,14.21,0,0,1-1.53-2.12l-3.57-5.2-3.63-5.14a16.41,16.41,0,0,1-1.46-2.18,14.78,14.78,0,0,1,1.7,2c1,1.27,2.34,3.06,3.75,5.09s2.62,3.9,3.46,5.28A14.47,14.47,0,0,1,144.56,385.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.58,356.81c.06.1-3.73,2.65-8.47,5.7s-8.63,5.43-8.69,5.33,3.72-2.65,8.46-5.7S138.51,356.71,138.58,356.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.27,368.34a68.36,68.36,0,0,1-5.74-5.29,74.6,74.6,0,0,1-5.43-5.61,69.64,69.64,0,0,1,5.74,5.3A73.47,73.47,0,0,1,149.27,368.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,368.11l3.26-.27a16,16,0,0,0,6.57-2,27.36,27.36,0,0,1,3.06-1.54c4-1.61,8.51-1.32,12.84-1.54a53.12,53.12,0,0,0,20.43-5.22,2,2,0,0,0,.89-.81c.67-1.22-.57-2.3-1.64-3-5.48-3.38-11.06-6.8-17.28-8.48s-13.27-1.39-18.58,2.26c-6.22,4.29-8.49,13.09-9.55,20.57",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.07,356.32a3.6,3.6,0,0,1-.55-.26l-1.54-.81c-1.34-.7-3.27-1.74-5.7-2.9a52.25,52.25,0,0,0-8.82-3.4A29.08,29.08,0,0,0,171,348a19.55,19.55,0,0,0-10.42,4.48,23.11,23.11,0,0,0-5.43,7.62c-1.14,2.43-1.84,4.51-2.36,5.93l-.58,1.64a3.35,3.35,0,0,1-.22.56,2.51,2.51,0,0,1,.14-.59c.13-.42.3-1,.5-1.67a55.16,55.16,0,0,1,2.25-6,23,23,0,0,1,5.43-7.79A19.84,19.84,0,0,1,171,347.59a29.12,29.12,0,0,1,11.59,1,52.41,52.41,0,0,1,8.85,3.51c2.42,1.21,4.33,2.29,5.64,3l1.5.88A3.06,3.06,0,0,1,199.07,356.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.26,360.52c-.07.1-4.32-2.66-9.51-6.15s-9.33-6.41-9.26-6.51,4.32,2.66,9.51,6.15S191.32,360.42,191.26,360.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.72,347.64a10.86,10.86,0,0,1-3.1.56,10.4,10.4,0,0,1-3.16-.05,21,21,0,0,1,3.12-.31A21,21,0,0,1,186.72,347.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.09,345.21a8.23,8.23,0,0,1-1.4,2.18,9.25,9.25,0,0,1-1.76,2,8,8,0,0,1,1.39-2.18A9.44,9.44,0,0,1,168.09,345.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.9,363a10.82,10.82,0,0,1-2.05-1.11c-1.22-.74-2.89-1.84-4.66-3.12s-3.34-2.51-4.47-3.4a12.37,12.37,0,0,1-1.76-1.52,12.34,12.34,0,0,1,1.95,1.27l4.53,3.3c1.77,1.28,3.4,2.41,4.58,3.22A14.22,14.22,0,0,1,171.9,363Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.75,381.94c-3.11-.82-6.81,2.19-7.45,5.34s.54,6.36,1.92,9.26a47.3,47.3,0,0,0,12.84,16.79,31.78,31.78,0,0,0,19.62,7.23c-1.31-6.1.35-12.46-.38-18.65a24.27,24.27,0,0,0-21.49-21.28c-2-.21-4.27-.52-5.06,1.31",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.68,420.56a2.18,2.18,0,0,1-.44-.21,7.51,7.51,0,0,1-1.16-.78,12.06,12.06,0,0,1-3.07-4.1c-.49-1-1-2-1.58-3.16s-1.09-2.39-1.67-3.69a37.28,37.28,0,0,0-2.06-3.94,30.91,30.91,0,0,0-2.82-3.84c-2.12-2.5-4.4-4.66-6.38-6.72a42.3,42.3,0,0,1-4.86-5.84,21.2,21.2,0,0,1-2.38-4.54,13.87,13.87,0,0,1-.42-1.33,1.43,1.43,0,0,1-.09-.47s.21.63.66,1.74a23.53,23.53,0,0,0,2.48,4.43,45.25,45.25,0,0,0,4.9,5.73c2,2,4.27,4.2,6.42,6.72a31.36,31.36,0,0,1,2.86,3.9,37,37,0,0,1,2.05,4l1.63,3.7c.52,1.15,1.06,2.21,1.54,3.17a12.27,12.27,0,0,0,2.9,4.11C183.09,420.22,183.71,420.51,183.68,420.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.63,415.49a9.56,9.56,0,0,1,.29-2.09c.24-1.28.64-3,1.18-4.94s1.11-3.62,1.57-4.83a9.39,9.39,0,0,1,.85-1.93,11.5,11.5,0,0,1-.56,2c-.38,1.24-.91,2.95-1.45,4.86s-1,3.63-1.29,4.89A11,11,0,0,1,167.63,415.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.09,400.53a12.36,12.36,0,0,1-2.18-.5c-1.34-.35-3.19-.83-5.24-1.29s-3.93-.82-5.29-1.08a13.48,13.48,0,0,1-2.19-.48,10.24,10.24,0,0,1,2.24.18c1.38.18,3.27.49,5.33,1s3.91,1,5.23,1.42A10.54,10.54,0,0,1,183.09,400.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.12,404.88a12.24,12.24,0,0,1,.33-2.42c.27-1.48.71-3.52,1.29-5.74s1.2-4.22,1.68-5.64a13.87,13.87,0,0,1,.89-2.28,14.19,14.19,0,0,1-.59,2.37c-.42,1.44-1,3.44-1.56,5.66s-1.06,4.23-1.41,5.7A15.49,15.49,0,0,1,156.12,404.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,387.5c0,.12-3.88-.2-8.65-.7s-8.62-1-8.61-1.13a85.15,85.15,0,0,1,8.66.7A84.55,84.55,0,0,1,176,387.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.13,434.48c0,.12-13.61.22-30.41.22s-30.42-.1-30.42-.22,13.62-.21,30.42-.21S173.13,434.36,173.13,434.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.66,452c0,.12-9.18.21-20.49.21s-20.5-.09-20.5-.21,9.18-.22,20.5-.22S163.66,451.89,163.66,452Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.3,454.51c0,.12-9,.22-20.13.22s-20.14-.1-20.14-.22,9-.21,20.14-.21S163.3,454.39,163.3,454.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,449.94c0,.12-9.49.22-21.2.22s-21.2-.1-21.2-.22,9.49-.21,21.2-.21S164,449.82,164,449.94Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.33,106.88l7.55-13.3a35.64,35.64,0,1,1,8.54,9.5h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.33,106.88,332.4,103l-.06.18h0a.12.12,0,0,1,0-.17.12.12,0,0,1,.14,0,36.68,36.68,0,0,0,7.29,4.35,36.07,36.07,0,0,0,9.7,2.72,32,32,0,0,0,5.58.26c1-.06,1.94-.08,2.92-.17l3-.46a35.54,35.54,0,0,0,22-14.17,35.07,35.07,0,0,0,5.93-13.6,35.8,35.8,0,0,0-.43-15.63,34.68,34.68,0,0,0-7.53-14.46l-1.44-1.58c-.47-.53-1-1-1.55-1.45a19.06,19.06,0,0,0-1.59-1.39l-1.68-1.26A14.33,14.33,0,0,0,372.89,45l-1.78-1.08L369.24,43a17.42,17.42,0,0,0-1.88-.84,36,36,0,0,0-15.76-2.43A34.62,34.62,0,0,0,337.12,44a35.81,35.81,0,0,0-16.76,20.53A38.41,38.41,0,0,0,318.79,76,35.39,35.39,0,0,0,324,93.52a.13.13,0,0,1,0,.12c-4.87,8.44-7.25,12.55-7.65,13.24l7.45-13.36v.12A35.42,35.42,0,0,1,318.47,76,38.55,38.55,0,0,1,320,64.4a36.12,36.12,0,0,1,16.9-20.8,35.11,35.11,0,0,1,14.66-4.33,36.12,36.12,0,0,1,16,2.45,15.45,15.45,0,0,1,1.91.85l1.89.92,1.81,1.09a18.67,18.67,0,0,1,1.77,1.17L376.62,47a21.37,21.37,0,0,1,1.61,1.41c.52.49,1.09.94,1.57,1.47l1.45,1.61a35,35,0,0,1,7.63,14.64A36.14,36.14,0,0,1,389.3,82a35.55,35.55,0,0,1-6,13.76A36,36,0,0,1,361,110.05l-3,.45c-1,.08-2,.11-2.95.16a31.69,31.69,0,0,1-5.64-.28,36,36,0,0,1-9.76-2.79,37,37,0,0,1-7.32-4.42l.16-.16h0a.12.12,0,0,1,0,.17l0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.1,70.61h2.32l5.06-7V58.94s3.58-.23,3.16,5.83,0,4.51,0,4.51,7.6,0,8.23.69c.46.48.67,8,.75,12.13a4.44,4.44,0,0,1-3.14,4.47,3.3,3.3,0,0,1-.82.11c-1.9,0-11.59-1.54-11.59-1.54h-4Z",
    className: "colorToChange",
    style: {
      fill: "#339F9A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.47 69.34 342.9 85.18 346.86 85.18 346.86 69.66 341.47 69.34",
    className: "colorToChange",
    style: {
      fill: "#339F9A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.89,103.36a34,34,0,0,1-18.68,5.33,62.65,62.65,0,0,0-6.28-.07,9.52,9.52,0,0,0-5.74,2.23,5.23,5.23,0,0,0-1.48,5.71c1.18,2.7,5,3.77,5.58,6.66.42,2.08-1.13,4.06-2.88,5.27s-3.79,2-5.26,3.54a7.23,7.23,0,0,0,3.59,12.06c1.49.35,3.32.36,4.13,1.66a4.7,4.7,0,0,1,.22,3.13,11.12,11.12,0,0,0,.85,6.58,6.11,6.11,0,0,0,5.37,3.47c.88,0,1.74-.3,2.62-.28a2.17,2.17,0,0,1,2.11,1.27,4.57,4.57,0,0,1-.08,1.8c-.32,2.95,2.62,5.26,5.47,6.1,5.69,1.7,12,.06,16.84-3.44s8.15-8.68,10.4-14.18,3.46-11.34,4.66-17.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.45,250.45a12.32,12.32,0,0,0-2.81-4.19c-7.53-8-18.94-11.85-29.91-11.22s-21.48,5.4-30,12.31c-4.55,3.69-10.69,10.8-12.29,16.44,6.68,1.61,16.66-.63,23-3.38s12.54-6.07,19.37-6.77c7.92-.81,15.7,2,23.5,3.59a15.06,15.06,0,0,0,4.77.38,5.68,5.68,0,0,0,4.06-2.28A5.57,5.57,0,0,0,294.45,250.45Z",
    className: "colorToChange",
    style: {
      fill: "#339F9A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M294.45,250.45a12.32,12.32,0,0,0-2.81-4.19c-7.53-8-18.94-11.85-29.91-11.22s-21.48,5.4-30,12.31c-4.55,3.69-10.69,10.8-12.29,16.44,6.68,1.61,16.66-.63,23-3.38s12.54-6.07,19.37-6.77c7.92-.81,15.7,2,23.5,3.59a15.06,15.06,0,0,0,4.77.38,5.68,5.68,0,0,0,4.06-2.28A5.57,5.57,0,0,0,294.45,250.45Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M289,345.85l19.07-12.35s19,15.23,22.71,13.29L308.14,309l-30.51,18Z",
    className: "colorToChange",
    style: {
      fill: "#339F9A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.42,322.78a1.8,1.8,0,0,1,1.12-2.13,1.73,1.73,0,0,1,2.12,1.1,1.9,1.9,0,0,1-1.2,2.24,1.8,1.8,0,0,1-2.08-1.38",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.14,309l-3,1.94L328,346.44s1.74,1.25,2.81.35Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M308.23,334.22c.18-.11-.29-1.09-.24-2.35s.54-2.21.37-2.34-1.08.79-1.11,2.32S308.09,334.37,308.23,334.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.25,337.21c.2-.06,0-1,.44-2.15s1.13-1.77,1-1.95-1.23.33-1.71,1.7S312.07,337.31,312.25,337.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.35,336.62c-.07-.19-1.14.11-1.87,1.19s-.61,2.18-.41,2.17.42-.87,1-1.75S318.44,336.82,318.35,336.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.57,336.56c.13-.18-.64-.88-1.19-2s-.71-2.1-.93-2.1-.4,1.17.27,2.45S303.48,336.74,303.57,336.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.01 318.49 300.68 338.27 297.77 340.33 287.77 321.04 292.01 318.49",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.65,240.88c-.78,0-26.43-.57-40.28,8.58l-11,6.18.29,11.1s-2.35,3.92-1.83,6.27-.07,12.28-.07,12.28-4.11.26-4.63,7.32c0,0-5.7,2.35-8.2,6.53s-28.12,51.21-29.68,58.79-2.62,20.9,3.13,25.34S207,386.14,207,386.14s1.83,5.49,13.07,5.75,28.47-12.8,28.47-12.8l51.74-35.27L288,317.61l-18.07,11.05,19.33-22.47s8.89-15.15,6.27-31.09C293.6,263.27,280.65,240.88,280.65,240.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.08,249l-.61,0h-1.74c-1.52,0-3.7,0-6.4,0s-5.92.13-9.46.51a52.32,52.32,0,0,0-11.3,2.36c-7.81,2.64-14.09,6.83-18.56,9.82l-5.26,3.64-1.43,1a2.2,2.2,0,0,1-.52.31s.14-.15.45-.4l1.38-1.06c1.21-.92,3-2.23,5.17-3.79,4.43-3.07,10.71-7.34,18.6-10a51.28,51.28,0,0,1,11.42-2.35,92.69,92.69,0,0,1,9.51-.39c2.7,0,4.89.1,6.4.18l1.74.1A2.3,2.3,0,0,1,285.08,249Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.29,257.16a3,3,0,0,0-.81,1.5,1.78,1.78,0,0,0,.54,1.61,2,2,0,0,0,2,.42,2,2,0,0,0,1.16-1.68,1.79,1.79,0,0,0-.71-1.55,2.9,2.9,0,0,0-1.63-.52s.15-.13.49-.15a2.15,2.15,0,0,1,1.35.38,2.12,2.12,0,0,1,1,1.86,2.3,2.3,0,0,1-4,1.59,2.17,2.17,0,0,1-.58-2,2.26,2.26,0,0,1,.72-1.21C232.1,257.17,232.28,257.13,232.29,257.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5,258.51c-.05.05-.41-.22-.92-.74a4.71,4.71,0,0,1-1.25-5.36c.23-.7.44-1.1.5-1.08s0,.47-.14,1.17a6.63,6.63,0,0,0-.09,2.67,6.79,6.79,0,0,0,1.26,2.36C241.28,258.1,241.55,258.46,241.5,258.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.67,257.18c0,.05-.4-.17-.87-.66a6,6,0,0,1-1.31-2.31,6,6,0,0,1-.05-3.68c.18,0,0,1.66.55,3.53A14.71,14.71,0,0,0,243.67,257.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.36,249c-.08,0-.11-.47-.18-1.21a9.83,9.83,0,0,0-.63-2.75,7.79,7.79,0,0,0-1.56-2.33c-.5-.54-.82-.88-.77-.94s.45.18,1,.67a6.41,6.41,0,0,1,1.78,2.4,7.39,7.39,0,0,1,.52,2.94A2.63,2.63,0,0,1,271.36,249Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.72,249c-.08,0-.09-.47-.08-1.2a9.61,9.61,0,0,0-.23-2.76,11.85,11.85,0,0,0-1.3-2.46c-.39-.62-.6-1-.54-1.07s.38.29.84.86a8.43,8.43,0,0,1,1.5,2.52,6.91,6.91,0,0,1,.09,2.94C274.9,248.51,274.79,249,274.72,249Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.49,362.58a5,5,0,0,1,.47-1.17c.35-.75.89-1.84,1.6-3.23,1.42-2.79,3.51-6.8,6.13-11.74,5.24-9.88,12.56-23.49,20.71-38.48l6-10.95a48.46,48.46,0,0,0,4.21-10.71,48,48,0,0,0,1-19.4,48.83,48.83,0,0,0-3.69-12.63c-.63-1.43-1.18-2.51-1.56-3.24l-.44-.83a1.86,1.86,0,0,1-.13-.29,1.64,1.64,0,0,1,.18.27l.48.8c.41.71,1,1.78,1.66,3.2A47.94,47.94,0,0,1,270,286.42a48.7,48.7,0,0,1-4.23,10.84c-1.92,3.53-3.91,7.19-5.94,10.94L239,346.61l-6.28,11.66-1.69,3.18-.42.84A1.82,1.82,0,0,1,230.49,362.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.2,328.74a4.4,4.4,0,0,1-.56.4l-1.66,1L279.85,334c-5.17,3.2-12.29,7.65-20.08,12.69S245,356.36,240,359.74l-6,4-1.65,1.06a3.87,3.87,0,0,1-.59.35,3,3,0,0,1,.53-.43l1.59-1.15,5.9-4.13c5-3.45,12-8.17,19.75-13.22s14.95-9.45,20.17-12.56c2.61-1.56,4.74-2.8,6.21-3.64l1.71-1A3.9,3.9,0,0,1,288.2,328.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.29,346.5a5.44,5.44,0,0,1-.48-1l-1.25-2.84c-1.08-2.39-2.62-5.67-4.35-9.28s-3.23-6.78-4.41-9.26l-1.31-2.82a5,5,0,0,1-.42-1.06,4.47,4.47,0,0,1,.6,1c.36.65.86,1.58,1.46,2.75,1.2,2.33,2.83,5.58,4.55,9.2s3.22,6.92,4.22,9.36c.5,1.21.87,2.21,1.1,2.91A5.19,5.19,0,0,1,296.29,346.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.49,362.58c-.09-.11,8.75-7.93,19.76-17.47s20-17.18,20.1-17.07S261.6,336,250.59,345.5,230.59,362.69,230.49,362.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.53,380.91a12.51,12.51,0,0,0,2.13-2.37c1.07-1.66,2.38-4.1,3.86-6.75s2.73-5.12,3.65-6.89a21.17,21.17,0,0,1,1.56-2.83,18.12,18.12,0,0,1-1.23,3c-.84,1.82-2.06,4.3-3.52,7s-2.84,5.06-4,6.71a8.17,8.17,0,0,1-1.66,1.73A2.24,2.24,0,0,1,219.53,380.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.9,383.74c-.08,0,.49-1.13,1.12-3a39.23,39.23,0,0,0,1.62-7.54,27.71,27.71,0,0,0,0-7.68,8.14,8.14,0,0,0-.67-2.2,4.37,4.37,0,0,1-.44-.73s.26.17.61.63a6.8,6.8,0,0,1,.86,2.23,24.52,24.52,0,0,1,.2,7.81,32.18,32.18,0,0,1-1.8,7.61,16,16,0,0,1-1,2.15C229.1,383.5,228.93,383.76,228.9,383.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.07,368.55a9,9,0,0,1,2-.64,31.7,31.7,0,0,0,4.61-1.64c3.47-1.62,5.74-3.85,5.86-3.69A6.66,6.66,0,0,1,229,364a18.19,18.19,0,0,1-4.19,2.7,22.36,22.36,0,0,1-4.74,1.53A7.49,7.49,0,0,1,218.07,368.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.3,295.89a1,1,0,0,1-.14.21l-.44.59c-.39.52-.95,1.29-1.62,2.31a51.85,51.85,0,0,0-4.74,9.22,120.3,120.3,0,0,0-4.57,14.7c-1.49,5.61-3,11.86-5.51,18.1s-5.77,11.78-7.83,17.2a42.24,42.24,0,0,0-3.11,14.95A26,26,0,0,0,204,379a25.29,25.29,0,0,0,1.43,4.21,24.76,24.76,0,0,0,1.29,2.51c.14.26.26.47.36.64a1.43,1.43,0,0,1,.11.23,1,1,0,0,1-.16-.2l-.4-.61a22.56,22.56,0,0,1-1.39-2.48,24.37,24.37,0,0,1-1.52-4.23,26.15,26.15,0,0,1-.75-5.91,41.74,41.74,0,0,1,3-15.12c2.05-5.47,5.22-11.06,7.79-17.23s4-12.42,5.52-18a116.45,116.45,0,0,1,4.7-14.72,48.57,48.57,0,0,1,4.91-9.19c.7-1,1.29-1.77,1.71-2.26l.48-.56C231.23,296,231.29,295.88,231.3,295.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,264.33a9.85,9.85,0,0,1-.52,1.22,14.13,14.13,0,0,0-1,3.44,16.54,16.54,0,0,0,.18,5.28c.31,2,1.14,4,1.7,6.34a10.77,10.77,0,0,1,.29,3.46,20.38,20.38,0,0,1-.51,3.17,50,50,0,0,1-1.55,5.17c-.51,1.45-1,2.6-1.28,3.4a6,6,0,0,1-.55,1.21,7.28,7.28,0,0,1,.36-1.28c.3-.91.67-2.07,1.12-3.45s1-3.19,1.43-5.16a13.48,13.48,0,0,0,.18-6.4c-.54-2.23-1.38-4.34-1.66-6.38a16,16,0,0,1-.08-5.42,12.16,12.16,0,0,1,1.17-3.46,7.63,7.63,0,0,1,.49-.86C232.89,264.42,233,264.32,233,264.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.2,294.42a12.67,12.67,0,0,0,2.52-4.26,16,16,0,0,0,.78-5.3,37.52,37.52,0,0,0-.82-6.58,63.77,63.77,0,0,1-1.11-6.61,25.81,25.81,0,0,1,.11-5.5,15.05,15.05,0,0,1,.88-3.6,6.9,6.9,0,0,1,.42-.91c.12-.2.18-.3.2-.3s-.17.46-.43,1.28a17.6,17.6,0,0,0-.71,3.58,28.59,28.59,0,0,0,0,5.4c.19,2,.69,4.23,1.14,6.56a35.23,35.23,0,0,1,.79,6.68,15.45,15.45,0,0,1-.92,5.42,10.32,10.32,0,0,1-1.86,3.22,7.62,7.62,0,0,1-.72.71C234.31,294.36,234.21,294.43,234.2,294.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.56,286.54a6.42,6.42,0,0,1-1.21.22c-.78.1-1.91.28-3.29.52A69.43,69.43,0,0,0,244.44,290a70.44,70.44,0,0,0-10.05,4.39c-1.24.67-2.23,1.22-2.91,1.62a5.2,5.2,0,0,1-1.09.57,5.65,5.65,0,0,1,1-.74c.65-.45,1.62-1.06,2.84-1.77A58.63,58.63,0,0,1,255,286.91c1.4-.19,2.54-.31,3.33-.35A5,5,0,0,1,259.56,286.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.19,275.63c0,.1-1.48.08-3.81.44a28.34,28.34,0,0,0-4,.94,28.3,28.3,0,0,0-8.92,4.68,28.35,28.35,0,0,0-3.07,2.78c-1.62,1.71-2.44,2.94-2.52,2.88a3.65,3.65,0,0,1,.52-.9,18.71,18.71,0,0,1,1.73-2.23,24.63,24.63,0,0,1,3-2.91,29.09,29.09,0,0,1,4.3-2.82,29.44,29.44,0,0,1,4.78-1.94,24.61,24.61,0,0,1,4.11-.84,18.73,18.73,0,0,1,2.83-.16A4.52,4.52,0,0,1,261.19,275.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.42,298.51a5.36,5.36,0,0,1-1.12.43c-.74.24-1.79.6-3.1,1.06a96.35,96.35,0,0,0-9.93,4.19,93.71,93.71,0,0,0-9.36,5.32c-1.16.75-2.09,1.37-2.73,1.81a5.46,5.46,0,0,1-1,.63,5.11,5.11,0,0,1,.91-.79c.6-.49,1.5-1.16,2.64-2a72.63,72.63,0,0,1,9.34-5.49,74.8,74.8,0,0,1,10-4.07c1.32-.41,2.4-.72,3.15-.9A4.88,4.88,0,0,1,263.42,298.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,272.34a4.59,4.59,0,0,1-1-.33c-.62-.24-1.53-.58-2.71-1a50.83,50.83,0,0,0-10-2.19l.25-.23c.12,4.31.09,9.42-.29,14.87a122.43,122.43,0,0,1-2.11,15.81v-.11a76.13,76.13,0,0,0,3.33,8.88c.47,1,.9,1.82,1.19,2.36a7.59,7.59,0,0,1,.47.81,4.65,4.65,0,0,1-.58-.75,23,23,0,0,1-1.31-2.31,67.12,67.12,0,0,1-3.51-8.86l0-.05v-.06a134.37,134.37,0,0,0,2-15.76c.38-5.43.43-10.52.37-14.82v-.26l.26,0a46.92,46.92,0,0,1,10,2.38c1.17.43,2.06.82,2.67,1.09A6.14,6.14,0,0,1,295,272.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.76,276.68a12.72,12.72,0,0,1-2.1-.58c-1.28-.38-3.07-.88-5.06-1.34-4-.94-7.26-1.54-7.24-1.69a8.75,8.75,0,0,1,2.18.19c1.34.19,3.17.51,5.18,1C292.75,275.16,295.83,276.54,295.76,276.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,261.29c0,.07-1.22-.28-3.17-.74a54.72,54.72,0,0,0-7.72-1.23,60,60,0,0,0-7.82-.1,29,29,0,0,1-3.26.12,3,3,0,0,1,.86-.2c.56-.09,1.37-.2,2.37-.29a46.06,46.06,0,0,1,7.89-.05,42.36,42.36,0,0,1,7.77,1.39c1,.28,1.75.53,2.27.74A2.8,2.8,0,0,1,291,261.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.61,265.8a7.27,7.27,0,0,1-1.33.41c-.86.23-2.12.51-3.7.79a50.68,50.68,0,0,1-12.45.62c-2.41-.24-4.82-.5-6.7-1.68a5.85,5.85,0,0,1-2.09-2.26A4.29,4.29,0,0,1,244,261a13.93,13.93,0,0,1,1.11-3.63,4.23,4.23,0,0,1,.71-1.2s-.2.45-.52,1.27a16.27,16.27,0,0,0-.94,3.61,4,4,0,0,0,.38,2.41,5.3,5.3,0,0,0,2,2c1.75,1.08,4.1,1.34,6.49,1.57a56.07,56.07,0,0,0,12.36-.47c1.57-.22,2.84-.45,3.71-.62A7.37,7.37,0,0,1,270.61,265.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.06,86.56c-4.78-10.36-16.61-8.32-22.27-5.57a25,25,0,0,0-12.51,13.25c-1.66,4-3,8.56-6.34,11a47.52,47.52,0,0,1-4.75,2.47,6.17,6.17,0,0,0-3.33,4.21c-.5,3.45,3,5.84,5.88,7.23-1.73,1.18-2.18,3.85-1.57,6a15.44,15.44,0,0,0,3.42,5.5,84.75,84.75,0,0,0,17.35,14.63c5.46,3.4,9,3.8,14.86,1.36,2.38-1,4.6-2.62,7.14-2.91,2.95-.33,5.77,1.18,8.69,1.79s6.6-.23,7.55-3.3a22.65,22.65,0,0,0,.4-3.71c.15-1.23.76-2.57,1.87-2.85.9-.23,1.8.32,2.68.61,2.11.7,5.29,16.36,7.31,15.41,0,0,2.94-26.54-2.72-42.07-1.81-5-5.67-15.52-8.75-19.63-4.24-5.64-14.4-4.39-14.91-3.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,88.28c-7.53-2.63-17.69,3.15-20,10.78-2.57,8.47-5.36,18.92-5.85,25.58-1,13.39,8.53,17.36,8.53,17.36l-3.87,20.93,32.63-10.55,11.39-49.32,1.06-4.14Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,109.38c.11.29,1.66-.13,3.36.54s2.62,2,2.88,1.88.08-.5-.31-1.11a4.64,4.64,0,0,0-2.21-1.76,4.41,4.41,0,0,0-2.78-.18C242.27,109,242,109.25,242,109.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.89,113.83c.2.23,1.55-.63,3.37-.5s3.1,1.13,3.32.92-.08-.51-.64-1a4.68,4.68,0,0,0-2.63-1,4.52,4.52,0,0,0-2.71.67C259,113.33,258.8,113.72,258.89,113.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.31,121.32a11.86,11.86,0,0,0-2.77-1.2c-.44-.16-.85-.35-.85-.68a2.31,2.31,0,0,1,.62-1.27l2.15-3.15c3-4.49,5.33-8.23,5.15-8.35s-2.78,3.42-5.81,7.91c-.73,1.12-1.43,2.17-2.1,3.19a2.66,2.66,0,0,0-.66,1.73,1.2,1.2,0,0,0,.59.84,4.05,4.05,0,0,0,.75.29A11.83,11.83,0,0,0,251.31,121.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.69,142a35.07,35.07,0,0,0,18.81-.47s-6.33,8.06-19.42,3.74Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.34,127.3c-.17-.22.08.27,0,0Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.15,126.43a3.32,3.32,0,0,0-2-1.74,3.7,3.7,0,0,0-3.53.57,2.29,2.29,0,0,0-.31,2c.63.81.69,1.49,1.57,2a4.61,4.61,0,0,0,3.84-.44A2.12,2.12,0,0,0,256.15,126.43Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.27,123.78c-.29-.08-.75,1.85-2.72,2.83s-4,.29-4.07.56c0,.11.37.48,1.24.71a4.93,4.93,0,0,0,3.36-.35,4.31,4.31,0,0,0,2.16-2.41C256.51,124.33,256.4,123.8,256.27,123.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.57,104.4c-.1.51,1.39,1,2.9,2.14s2.54,2.31,3,2c.2-.14.19-.67-.11-1.38a5.5,5.5,0,0,0-1.83-2.2,5.2,5.2,0,0,0-2.64-1C263.1,104,262.62,104.16,262.57,104.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.1,102.53c.39.38,1.76-.19,3.44-.37s3.15,0,3.44-.48c.12-.23-.14-.62-.81-1a5.25,5.25,0,0,0-2.87-.41,5.16,5.16,0,0,0-2.67,1.09C243.07,101.9,242.92,102.34,243.1,102.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.73,98.89a5.15,5.15,0,0,0-2.5-2.23,167,167,0,0,0-20.12-9.36l-2.84,1.61a14.1,14.1,0,0,0,6.9,14.08c1.94,1.08,4.46,2.1,4.71,4.31s-2.14,3.85-3.49,5.71a7.2,7.2,0,0,0-.23,8c.87,1.35,2.19,2.37,3,3.76a7.17,7.17,0,0,1,.27,6.17c-.81,2-2.16,4.63-4,5.74a12.23,12.23,0,0,0,13.09-5.51c1.52-2.58,1.64-5.71,1.84-8.7a111.63,111.63,0,0,1,3.23-20.15A5.3,5.3,0,0,0,287.73,98.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.56,87.61a27.65,27.65,0,0,1-6.23,6c-2.46,1.53-5.6,2.25-8.29,1.17.67-.74,1.35-1.48,2-2.23a41.63,41.63,0,0,1-15.91,6.58c3.58-4.35,7.27-8.79,12.16-11.6s11.3-3.67,16.07-.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.39,112.9l-15.24,11.84c1.75,1.91,1.07,6.77-.65,8.7s-4,3.58-4.67,6.08c-.74,2.73.71,5.56.75,8.39.06,4-2.63,7.44-4.71,10.86s-3.58,8-1.26,11.27c2.61,3.68,8.52,3.15,12.09.4s5.61-7,8.26-10.64,6.79-6.43,11.28-6A86.25,86.25,0,0,0,288.39,112.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.94,145.91c-.09-.17.81-.82,2.35-2.06a30.52,30.52,0,0,0,5.76-5.84,19.16,19.16,0,0,0,2.57-4.89,15.42,15.42,0,0,0,.9-6.12,13.76,13.76,0,0,0-2.09-6.38,21.22,21.22,0,0,0-5.07-5.46c-4.1-3.19-9-5-13.28-6.91a47.88,47.88,0,0,1-11.18-6.14,20.39,20.39,0,0,1-5.69-6.55c-.93-1.85-1.08-3-.94-3s.67.93,1.8,2.51a23.59,23.59,0,0,0,5.92,5.6A53.26,53.26,0,0,0,283,106c2.18.87,4.51,1.77,6.89,2.87A36.39,36.39,0,0,1,297,113.1a23.21,23.21,0,0,1,5.65,6.19,15.9,15.9,0,0,1,2.31,7.59,17.18,17.18,0,0,1-1.28,7,19.81,19.81,0,0,1-3.14,5.25,24.6,24.6,0,0,1-6.64,5.55C292.09,145.7,291,146.05,290.94,145.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.23,110a6.46,6.46,0,0,1-1.33-.43c-.84-.31-2-.78-3.53-1.4a44.82,44.82,0,0,1-10.89-6.2,22.07,22.07,0,0,1-7.23-10.16,14.36,14.36,0,0,1-.71-3.75,9.28,9.28,0,0,1,0-1,1.34,1.34,0,0,1,0-.36,23.86,23.86,0,0,0,1,5,23,23,0,0,0,7.22,9.87,49.74,49.74,0,0,0,10.71,6.27l3.46,1.54A7.79,7.79,0,0,1,291.23,110Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.71,125.14c-.06,0,.25-.6.41-1.72a8.51,8.51,0,0,0-.81-4.67,13.31,13.31,0,0,0-4.62-5.32c-2.19-1.59-4.91-2.85-7.63-4.48a27.42,27.42,0,0,1-6.82-5.74,28.16,28.16,0,0,1-4-6.11,24.76,24.76,0,0,1-1.67-4.61c-.16-.56-.22-1-.28-1.3a1.34,1.34,0,0,1-.06-.46,15.94,15.94,0,0,1,.53,1.71,29,29,0,0,0,1.81,4.5,28.7,28.7,0,0,0,4,6,27.49,27.49,0,0,0,6.72,5.62c2.68,1.6,5.42,2.89,7.64,4.53a13.46,13.46,0,0,1,4.68,5.56,8.41,8.41,0,0,1,.67,4.85,5.48,5.48,0,0,1-.39,1.28C291.8,125,291.73,125.15,291.71,125.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.44,115s0-.06.09-.16a4.1,4.1,0,0,1,.33-.44,4.51,4.51,0,0,1,1.7-1.26,10.14,10.14,0,0,1,3.3-.57c1.29-.07,2.77-.17,4.4-.17a23.83,23.83,0,0,0,5.25-.49,12.93,12.93,0,0,0,5.27-2.77,23.19,23.19,0,0,0,4.3-5.1,68.17,68.17,0,0,0,3.43-6.36,52.44,52.44,0,0,1,3.6-6.34,19.45,19.45,0,0,1,4.72-4.92,19.72,19.72,0,0,1,10.85-3.54,18.57,18.57,0,0,1,7.6,1.34l1.12.49.77.44a4.51,4.51,0,0,1,.63.39,3.59,3.59,0,0,1-.67-.3l-.8-.39-1.12-.44a19.17,19.17,0,0,0-7.52-1.16,19.63,19.63,0,0,0-10.58,3.56,19,19,0,0,0-4.58,4.82A51.77,51.77,0,0,0,236,97.88a68.42,68.42,0,0,1-3.47,6.41,23.3,23.3,0,0,1-4.42,5.18,13.28,13.28,0,0,1-5.48,2.83,23.67,23.67,0,0,1-5.35.44c-1.63,0-3.09,0-4.39.09a10,10,0,0,0-3.23.47,4.51,4.51,0,0,0-1.7,1.14A6.26,6.26,0,0,1,207.44,115Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.32,101.51c-6-15.15-14-30-15.1-41.29l-11.95.48c.25,4.37,1.82,40.74,10.29,55.12s36.75,48,36.75,48l9.95-25.59S207.33,116.67,201.32,101.51Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.4,36.7h-5.23s.51,3.08,2.88,3.25,1.91-.37,1.91-.37l-.53.49-3.26.64s.16,2.54,2.31,2.94l3.17-2.94Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.72,36.24c-.48,3.94-.53,3.7-.53,3.7l-4.78,3.94-1.22-5.8a1.78,1.78,0,0,0-1.64-1.42l-2.17-.14s.84-3-1.89-2.75c0,0-1.5-.41-2.71,4.61-1.32,5.49-7,18.39-6.51,22.7l12.12.49c-.13-4,3.17-8.27,4.8-10.11a4.33,4.33,0,0,0,1-1.93,6.06,6.06,0,0,1,1.36-2.66c1.5-1.66,4.65-4.65,4.65-4.65V33.09S196.18,32.44,195.72,36.24ZM186,45.06l-2.49,1.13.42-2.54,2.07-.2Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.38,46.46a4.66,4.66,0,0,1,.12-1.07c.12-.69.29-1.67.52-2.89l.84-4.26a17.24,17.24,0,0,0,.41-2.49c0-.81-.3-1.74-1.17-1.79s-1.51.54-1.93,1.25a6,6,0,0,0-.48,1.16l-.39,1.19L180,41.7c-.39,1.18-.75,2.12-1,2.76a3.84,3.84,0,0,1-.49,1,4.2,4.2,0,0,1,.3-1c.21-.66.52-1.61.86-2.79s.75-2.64,1.19-4.18c.13-.4.25-.8.38-1.21a6,6,0,0,1,.51-1.26,3.91,3.91,0,0,1,.94-1.1,2,2,0,0,1,1.51-.41,2.24,2.24,0,0,1,.76.27,1.74,1.74,0,0,1,.54.61,3,3,0,0,1,.3,1.44,16.69,16.69,0,0,1-.45,2.57l-1,4.25c-.27,1.2-.5,2.18-.68,2.85A3.88,3.88,0,0,1,183.38,46.46Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.86,45.09a20.15,20.15,0,0,1-.15-2.94c0-.4-.06-.78-.09-1.13a1.07,1.07,0,0,0-.23-.73c-.34-.25-.75-.25-.73-.34s.09-.07.25-.09a1.12,1.12,0,0,1,.7.13,1.29,1.29,0,0,1,.48,1,8.15,8.15,0,0,1,.14,1.17A5.63,5.63,0,0,1,185.86,45.09Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.8,42.86s-.33.44-1,1A12.89,12.89,0,0,1,188,45.75a9.76,9.76,0,0,1-3.33.79,3.68,3.68,0,0,1-1.41,0,4.26,4.26,0,0,1,1.36-.33,12.89,12.89,0,0,0,3.16-.9,18.75,18.75,0,0,0,2.84-1.7C191.3,43.09,191.75,42.8,191.8,42.86Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.83,156.44s13.46-.4,21.52-2.8,39-9.76,39-9.76L397,135.6l1,12.84S351.87,161.93,342.91,165,293,182.12,285.26,180.34l-4.8-9.87Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.87,120.5c-.81-.18-4.83,1.65-4.83,1.65a2.69,2.69,0,0,0,.08-3.32l-5.52,2.71a57,57,0,0,1-4.61,4.19,62.57,62.57,0,0,0-7,7.61l-3.3,3.07,2.05,12.15A10.12,10.12,0,0,0,402,148c1.71-.79,4.21-4,4.21-4l4.71-.4a2.71,2.71,0,0,0,1.5-.59,3.94,3.94,0,0,0,1.17-3.22c3-1.7,1.25-3.86,1.25-3.86a3.72,3.72,0,0,0,2.42-1.33,2.25,2.25,0,0,0-.15-2.64c-.56-1-4.88-.69-4.88-.69L412,130s6.6-5.24,8.08-6.38S421.63,120.67,420.87,120.5Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.12,122a7,7,0,0,1-2,2.42,25,25,0,0,0-2.41,2.36,10,10,0,0,0-1.77,3.64,19.76,19.76,0,0,1-1.48,4,13.76,13.76,0,0,1-2,2.82,12.9,12.9,0,0,1-1.73,1.55,2.48,2.48,0,0,1-.73.43c-.06-.07.94-.76,2.19-2.23a14.66,14.66,0,0,0,1.85-2.79,21.39,21.39,0,0,0,1.42-3.88,10,10,0,0,1,1.89-3.8,21.35,21.35,0,0,1,2.54-2.33A25.8,25.8,0,0,0,416.12,122Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.69,139.76a7.18,7.18,0,0,1-2.2,1,11.07,11.07,0,0,1-2.62.54,10.61,10.61,0,0,1-1.59,0,3.46,3.46,0,0,1-1.69-.58,2,2,0,0,1-.84-1.64,2.48,2.48,0,0,1,.88-1.46,3,3,0,0,1,1.3-.73c.44-.12.84-.21,1.21-.28a6.86,6.86,0,0,1,2.42-.28c0,.06-.9.24-2.34.63l-1.16.34a2.6,2.6,0,0,0-1.1.67,2.15,2.15,0,0,0-.7,1.14,1.45,1.45,0,0,0,.64,1.19,5.09,5.09,0,0,0,2.94.54,12.21,12.21,0,0,0,2.54-.42C412.81,140.05,413.66,139.68,413.69,139.76Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,135.93a4.1,4.1,0,0,1-1.7.51,10,10,0,0,1-1.93.14,2.91,2.91,0,0,1-2.3-.88,2.29,2.29,0,0,1-.1-2.48,3.3,3.3,0,0,1,1.47-1.36,3.62,3.62,0,0,1,1.72-.49c0,.08-.63.28-1.54.81a3.16,3.16,0,0,0-1.22,1.26,1.84,1.84,0,0,0,.07,1.93,2.6,2.6,0,0,0,1.92.73,14.2,14.2,0,0,0,1.87,0A11.66,11.66,0,0,1,415,135.93Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.74,143.43a4.47,4.47,0,0,1-1.39.43,11.65,11.65,0,0,1-3.5.42,1.35,1.35,0,0,1-1.07-.45,1.55,1.55,0,0,1-.31-1,2,2,0,0,1,.84-1.48c.88-.53,1.52-.2,1.48-.16a2.77,2.77,0,0,0-1.26.46,1.65,1.65,0,0,0-.58,1.2,1.12,1.12,0,0,0,.22.69.85.85,0,0,0,.71.26,17.27,17.27,0,0,0,3.4-.26A3.86,3.86,0,0,1,411.74,143.43Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,199.07a4,4,0,0,1-.94.54,16.73,16.73,0,0,1-2.75,1,20.84,20.84,0,0,1-9.68.48,20.36,20.36,0,0,1-8.81-4,17.1,17.1,0,0,1-2.15-2,4.3,4.3,0,0,1-.66-.86c.08-.07,1.06,1.12,3,2.58a21.55,21.55,0,0,0,8.69,3.81,21.89,21.89,0,0,0,9.48-.31C262.57,199.7,263.94,199,264,199.07Z",
    className: "colorToChange",
    style: {
      fill: "#339F9A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.27,162.09s31.64-10.12,32.82-10.44,29.09,2.17,29.09,2.17S302,172.31,309,178.3h0l-20.53,7.4L282,203.51s-3.61,7.26-.74,14.07c5.43,12.89,14.85,33.23,13.46,35.56-.15.24-1-7-14.39-10.84-4.06-1.15-11.43-1.17-18.1.18-28.7,5.78-39.78,19-43,21.31,0,0,5.91-46.37,3.12-53.61s-5.75-12-3.45-18.41S224.65,175,224.65,175L213.34,162.2l15.8-26.27,14.46,12Z",
    className: "colorToChange",
    style: {
      fill: "#339F9A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.79,205.05a4.26,4.26,0,0,1-1.09,0,17,17,0,0,1-2.95-.38,18.26,18.26,0,0,1-8.62-4.53,17.14,17.14,0,0,1-4.87-8.42,15.57,15.57,0,0,1-.4-3,3.82,3.82,0,0,1,.06-1.08,34.58,34.58,0,0,0,.7,3.94,17.81,17.81,0,0,0,4.87,8.14,19.06,19.06,0,0,0,8.35,4.54C250.24,205,251.79,205,251.79,205.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.08,165.85a10.6,10.6,0,0,1,2.2,5.45,10.75,10.75,0,0,1-.52,5.86,28.63,28.63,0,0,0,0-5.78A28.6,28.6,0,0,0,222.08,165.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.23,171.33c0,.08-.65.53-1.61,1.46a13.58,13.58,0,0,0-2.95,4.21,13,13,0,0,0-1.12,5c0,1.33.13,2.15,0,2.17a5.41,5.41,0,0,1-.41-2.17,11.66,11.66,0,0,1,1-5.23,12.06,12.06,0,0,1,3.17-4.28A5.6,5.6,0,0,1,289.23,171.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M247.09,204.36a14.52,14.52,0,0,1-7.92-4.48,16.38,16.38,0,0,1-3.43-4.75c-.72,3.14,3.65,8.71,7.91,10.76a15.34,15.34,0,0,0,13.72-.38A51.4,51.4,0,0,1,247.09,204.36Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M285.84,227.34c0,.06-.83-.57-2.47-1.31a18.82,18.82,0,0,0-7.39-1.54,27.42,27.42,0,0,0-11,2.23,71.17,71.17,0,0,0-12,6.88,127.28,127.28,0,0,1-22.11,12.27c-3,1.27-5.44,2.18-7.15,2.77-.85.31-1.52.52-2,.66a3.45,3.45,0,0,1-.7.19,3.32,3.32,0,0,1,.67-.29l1.94-.75c1.69-.65,4.12-1.6,7.07-2.92a135.26,135.26,0,0,0,22-12.36,69.18,69.18,0,0,1,12.11-6.9A27.41,27.41,0,0,1,276,224.12a18.3,18.3,0,0,1,7.47,1.73A11.34,11.34,0,0,1,285.84,227.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.12,210.76a18.66,18.66,0,0,0-1.9-1.48,13.32,13.32,0,0,0-6.17-1.94,21.16,21.16,0,0,0-9.46,1.74,113.31,113.31,0,0,0-10.71,5.34,103.73,103.73,0,0,1-10.83,5.22,41.1,41.1,0,0,1-9.5,2.54,27.16,27.16,0,0,1-6.62.11,17.32,17.32,0,0,1-1.78-.29,2.78,2.78,0,0,1-.61-.16c0-.05.86.12,2.41.25a30,30,0,0,0,6.55-.27,42.74,42.74,0,0,0,9.37-2.62A111.87,111.87,0,0,0,251.63,214a109.33,109.33,0,0,1,10.78-5.33,21.3,21.3,0,0,1,9.67-1.66,13,13,0,0,1,6.25,2.14A7,7,0,0,1,280.12,210.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.88,198.16s-.21.21-.64.52a6.59,6.59,0,0,1-.82.52,10.55,10.55,0,0,1-1.13.6,16.61,16.61,0,0,1-3.15,1.11,19.39,19.39,0,0,1-4.06.52A19.92,19.92,0,0,1,224,201a16.54,16.54,0,0,1-3.18-1,11.3,11.3,0,0,1-1.15-.56,5.83,5.83,0,0,1-.83-.5c-.44-.29-.67-.47-.65-.5s1,.55,2.77,1.22a19.6,19.6,0,0,0,3.13.89,21.52,21.52,0,0,0,4,.35,20.85,20.85,0,0,0,3.95-.47,18.5,18.5,0,0,0,3.11-1C236.86,198.74,237.82,198.08,237.88,198.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.89,195.65a2,2,0,0,1-.39.34,8.68,8.68,0,0,1-1.26.79,13.8,13.8,0,0,1-5.24,1.51,23.83,23.83,0,0,1-8.05-.74c-3-.72-6.11-1.89-9.46-2.84a43.13,43.13,0,0,0-17.66-1.14,44.32,44.32,0,0,0-5.31,1.09c-1.23.33-1.91.54-1.92.5s.15-.09.47-.21.78-.3,1.4-.48a37,37,0,0,1,5.3-1.26,41.6,41.6,0,0,1,17.86,1c3.38,1,6.5,2.14,9.43,2.87a24.12,24.12,0,0,0,7.91.84,14.55,14.55,0,0,0,5.18-1.32C284.3,196.05,284.86,195.6,284.89,195.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.06,180.64a3,3,0,0,1-.64.1c-.42,0-1,.12-1.85.18a35.35,35.35,0,0,1-6.79-.49c-2.84-.46-6.16-1.3-9.82-2.29a74.13,74.13,0,0,0-12-2.5,31.65,31.65,0,0,0-3.21-.1c-.53,0-1.05,0-1.57.05l-1.53.18a28.24,28.24,0,0,0-5.71,1.43c-3.56,1.26-6.67,2.71-9.4,3.63a25.23,25.23,0,0,1-6.64,1.46,10.33,10.33,0,0,1-1.85,0,2.74,2.74,0,0,1-.65-.06,4.21,4.21,0,0,1,.65,0,14.11,14.11,0,0,0,1.83-.11,26.81,26.81,0,0,0,6.54-1.61c2.69-.95,5.77-2.43,9.36-3.73a28.71,28.71,0,0,1,5.79-1.49l1.57-.19c.53,0,1.06,0,1.6,0a32.45,32.45,0,0,1,3.26.1,72.57,72.57,0,0,1,12.1,2.55c3.65,1,6.94,1.9,9.76,2.4a38,38,0,0,0,6.72.64l1.84-.07A2.74,2.74,0,0,1,284.06,180.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,153.81c.09.05-.93,1.51-1.89,4.16a21.4,21.4,0,0,0-1,10.81,21.86,21.86,0,0,0,4.52,9.87c1.78,2.19,3.21,3.25,3.14,3.33a5.29,5.29,0,0,1-1-.72,19.26,19.26,0,0,1-2.41-2.38,21.14,21.14,0,0,1-4.76-10,20.8,20.8,0,0,1,1.14-11,19,19,0,0,1,1.51-3A5.56,5.56,0,0,1,294,153.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.25,157a2.64,2.64,0,0,1-.88.2,22.23,22.23,0,0,1-2.47.27,13,13,0,0,1-3.69-.29,8.06,8.06,0,0,1-4-2.25c-1.16-1.14-2-2.38-2.93-3.41a11.25,11.25,0,0,0-2.7-2.34,7,7,0,0,0-3.13-.92,2,2,0,0,1,.91-.1,5.55,5.55,0,0,1,2.4.7,10.53,10.53,0,0,1,2.88,2.35c.93,1,1.82,2.26,2.93,3.35a7.93,7.93,0,0,0,3.71,2.16,13.81,13.81,0,0,0,3.56.38C240,157,241.25,156.87,241.25,157Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.24,461.52c-.14,0-.26-10.48-.26-23.41s.12-23.41.26-23.41.26,10.48.26,23.41S239.39,461.52,239.24,461.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.67,449.49c-.15,0-.26-10.48-.26-23.41s.11-23.41.26-23.41.26,10.48.26,23.41S243.81,449.49,243.67,449.49Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.32,477.13c0,.14-89.7.26-200.31.26s-200.33-.12-200.33-.26,89.68-.26,200.33-.26S450.32,477,450.32,477.13Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinished1);
export default __webpack_public_path__ + "static/media/finished-1.4f2c5814e8648919b8c3f4544cc9b154.svg";
export { ForwardRef as ReactComponent };